<app-page-heading [key]="'nav.load-management'"
                  [regions]="[]"
                  [carriers]="[]"
                  [info]="displayHeaderRightWarning"
                  [infoMessageKey]="'bluechat.search.cant-create-helper'"
                  [helper]="true"
                  [helperContent]="helper">
</app-page-heading>

<section class="container summary-panel space-top-20">

    <div class="alert-wrapper">
        <div class="alert alert-info">
            <i class="fa fa-info-circle m-r"></i>
            <div>
                <span [i18n]="'bluechat.search.blueyonder-only.line1'"></span><br>
            </div>
        </div>
    </div>

    <app-bluechat-filters [filters]="filters"
                          (reset)="reset()"
                          (apply)="search()">
    </app-bluechat-filters>

    <spacer [size]="16"></spacer>

    <app-bluechat-carriers-unknown [unknownCarrierDeliveries]="unknownCarriers"></app-bluechat-carriers-unknown>

    <spacer [size]="16"></spacer>

    <div class="row">
        <div class="col-sm-6">
            <span class="selectedDeliveriesNb"><h3 class="nb">{{selectedDeliveriesNumber}}</h3> <span [i18n]="'bluechat.search.selected-deliveries'"></span></span>
        </div>
        <div class="col-sm-6">
            <button class="btn btn-md btn-primary pull-right"
                    (click)="openBluechatMassCreationModal()"
                    [disabled]="!userHasBluechatEnabled || (!seeAllCarriers && selectedLoads.length <= 1)">
                <i class="fa fa-comments"></i>&nbsp;<span [i18n]="'bluechat.search.create-mass-notes'"></span>
            </button>
        </div>
    </div>

    <spacer [size]="16"></spacer>

    <app-bluechat-list [bluechatLoads]="bluechatLoads"
                       [carriers]="knownCarriersByBlueyonderCode"
                       [regions]="knownRegionsById"
                       [showByCarrier]="seeAllCarriers"
                       [selectedLoads]="selectedLoads"
                       [userCanCreateNote]="userHasBluechatEnabled"
                       (selectedLoadsChange)="updateSelectedLoads($event)"
                       (createNote)="openBluechatNoteCreationModal($event)"
                       (openDetail)="goToLoadDetail($event)"
    ></app-bluechat-list>
</section>

<ng-template #noteCreationModal>
    <bluechat-note-creation [deliveries]="noteDeliveries" [userBluechatConfig]="userBluechatConfig">
    </bluechat-note-creation>
</ng-template>

<ng-template #massCreationModal>
    <bluechat-mass-creation-note
        (creationFromListClicked)="noteDeliveries = $event"
        (creationFromCsvClicked)="noteDeliveries = $event"
        [loads]="noteLoads">
    </bluechat-mass-creation-note>
</ng-template>

<ng-template #helper>
    <h3 class="text-primary text-left" [i18n]="'bluechat.search.helper.title'"></h3>
    <spacer [size]="8"></spacer>
    <div class="text-left">
        <ul>
            <li><span [i18n]="'bluechat.search.helper.line1'"></span></li>
            <li><span [i18n]="'bluechat.search.helper.line2'"></span></li>
            <li><span [i18n]="'bluechat.search.helper.line3'"></span></li>
        </ul>
    </div>
</ng-template>
